import { Card } from 'antd';
import clsx from 'classnames';
import React, { FC } from 'react';
import './index.scss';
import type { CardProps } from 'antd';

export const TdsCard: FC<CardProps> = (props) => {
  const { className, children, ...rest } = props;

  return (
    <Card className={clsx('tds-card', className)} {...rest}>
      {children}
    </Card>
  );
};
